import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD3WQC4mGliLaTHL1pQfqXqO7vjh6OaiV8",
  authDomain: "bmai-c3d40.firebaseapp.com",
  projectId: "bmai-c3d40",
  storageBucket: "bmai-c3d40.appspot.com",
  messagingSenderId: "105608786874",
  appId: "1:105608786874:web:fe5fc04ddf33db94a12383",
  measurementId: "G-2L8J0Q38P5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, provider, db }; 